module.exports = __webpack_public_path__ + "img/icon_edit.9947ca62.svg";